import { Tween, Easing } from "es6-tween";

export default class ExamplesController {
	static DURATION = 1500;
	static CONTAINER = [];

	constructor() {
		this.responsiveGutterContainerProps = { width: 50 };
		this.responsiveGutterContainerTarget = { width: 100 };
		ExamplesController.CONTAINER = Array.from(
			document.querySelectorAll(".js-responsive-gutter-example")
		);

		this.tween = new Tween(this.responsiveGutterContainerProps)
			.to(this.responsiveGutterContainerTarget, ExamplesController.DURATION)
			.on("update", this.onTweenUpdate)
			.easing(Easing.Quadratic.InOut)
			.yoyo(true)
			.repeat(Infinity)
			.start();

		this.onTweenUpdate = ::this.onTweenUpdate;
		this.render = ::this.render;

		this.render();
	}

	onTweenUpdate(e) {
		ExamplesController.CONTAINER.forEach(container => {
			container.style.width = `${e.width}%`;
		});
	}

	render() {
		requestAnimationFrame(this.render);
		this.tween.update();
	}
}



// WEBPACK FOOTER //
// ./Components/ExamplesController.js